export const nsResources = {
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'amls:ui:ns-alerts-list:read',
  APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE: 'amls:ui:ns-investigation-page:read',
  APP_3_RESOURCE_UI_NS_RISK_VIEW: 'amls:ui:ns-risk-view:read',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG:
    'amls:ui:ns-iad-matching-config:read',
  APP_3_RESOURCE_UI_NS_IAD_SEGMENTS: 'amls:ui:ns-iad-segments:read',
  APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS: 'amls:ui:ns-iad-alert-details:read',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE:
    'amls:ui:ns-iad-matching-run-instance:read',
  APP_3_RESOURCE_UI_NS_IAD_WATCHLIST: 'amls:ui:ns-iad-watchlist:read',
  APP_3_RESOURCE_UI_NS_IAD_WHITELIST: 'amls:ui:ns-iad-whitelist:read',
  APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS:
    'amls:ui:ns-iad-ui-config-management:read',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'amls:ui:common-ticket:read',
  APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS: 'amls:ui:ns-iad-ticket-details:read',
  APP_3_RESOURCE_UI_ON_DEMAND_SCREENING: 'amls:ui:on-demand-screening:read',
  APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS:
    'amls:ui:common-notifications:read'
};

export const nsUserManagementResourcesArray = {
  nsDashboard: [
    'amls:ui:ns-alerts-hits-chart-widget:read',
    'amls:ui:ns-hits-distributtion-chart-widget:read',
    'amls:ui:ns-business-segment-parameters-chart-widget:read',
    'amls:ui:ns-customer-view-chart-widget:read'
  ],

  nsAlertListing: ['amls:ui:ns-alerts-list:read'],

  nsAlertDetails: [
    'amls:ui:ns-customer-profile-widget:read',
    'amls:ui:ns-alert-details-widget:read'
  ]
};

export const nsUserManagementResources = {
  // ns dashboard
  NS_ALERTS_HITS_CHART_WIDGET: 'amls:ui:ns-alerts-hits-chart-widget:read',
  NS_HITS_DISTRIBUTTION_CHART_WIDGET:
    'amls:ui:ns-hits-distributtion-chart-widget:read',
  NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET:
    'amls:ui:ns-business-segment-parameters-chart-widget:read',
  NS_CUSTOMER_VIEW_CHART_WIDGET: 'amls:ui:ns-customer-view-chart-widget:read',

  // ns alert listing
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'amls:ui:ns-alerts-list:read',

  // ns alert details
  NS_CUSTOMER_PROFILE_WIDGET: 'amls:ui:ns-customer-profile-widget:read',
  NS_ALERT_DETAILS_WIDGET: 'amls:ui:ns-alert-details-widget:read'
};

export const tmResources = {
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES:
    'amls:ui:tm-alert-list-anomalies:read',
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS: 'amls:ui:tm-alert-list-alerts:read',
  APP_3_RESOURCE_UI_TM_DASHBOARD: 'amls:ui:tm-dashboard:read',
  APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE: 'amls:ui:tm-investigation-page:read',
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'amls:ui:tm-anomaly-management:update',
  APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION:
    'amls:ui:tm-anomaly-investigation:update',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'amls:ui:tm-global-settings:read',
  APP_3_RESOURCE_UI_TM_CONFIGURATION: 'APP_3_RESOURCE_UI_TM_CONFIGURATION',
  APP_3_RESOURCE_UI_TM_IAD_FULLACCESS: 'amls:ui:tm-iad-fullaccess:read'
};

export const tmUserManagementResourcesArray = {
  tmDashboard: [
    'amls:ui:tm-alerts-anomalies-chart-widget:read',
    'amls:ui:tm-alerts-yield-chart-widget:read',
    'amls:ui:tm-no-issue-l1-chart-widget:read',
    'amls:ui:tm-str-chart-widget:read',
    'amls:ui:tm-segments-chart-widget:read',
    'amls:ui:tm-customer-view-chart-widget:read',
    'amls:ui:tm-cluster-view-chart-widget:read'
  ],

  tmAlertListing: ['amls:ui:tm-alerts-listing-widget:read'],
  tmAlertDetails: [
    'amls:ui:tm-anomaly-management:update',
    'amls:ui:tm-customer-profile-widget:read',
    'amls:ui:tm-associated-customer-widget:read',
    'amls:ui:tm-associated-accounts-widget:read',
    'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
    'amls:ui:tm-explainability-widget:read',
    'amls:ui:tm-transaction-details-widget:read',
    'amls:ui:tm-alert-details-widget:read',
    'amls:ui:tm-customer-activity-widget:read',
    'amls:ui:tm-additional-info-widget:read',
    'amls:ui:tm-risk-indicator-widget:read',
    'amls:ui:tm-cluster-information-widget:read'
  ]
};

export const tmUserManagementResources = {
  // tm dashboard
  TM_ALERTS_ANOMALIES_CHART_WIDGET:
    'amls:ui:tm-alerts-anomalies-chart-widget:read',
  TM_ALERTS_YIELD_CHART_WIDGET: 'amls:ui:tm-alerts-yield-chart-widget:read',
  TM_NO_ISSUE_L1_CHART_WIDGET: 'amls:ui:tm-no-issue-l1-chart-widget:read',
  TM_STR_CHART_WIDGET: 'amls:ui:tm-str-chart-widget:read',
  TM_SEGMENTS_CHART_WIDGET: 'amls:ui:tm-segments-chart-widget:read',
  TM_CUSTOMER_VIEW_CHART_WIDGET: 'amls:ui:tm-customer-view-chart-widget:read',
  TM_CLUSTER_VIEW_CHART_WIDGET: 'amls:ui:tm-cluster-view-chart-widget:read',

  // tm alerts listing
  TM_ALERTS_LISTING_WIDGET: 'amls:ui:tm-alerts-listing-widget:read',

  // tm alert details
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'amls:ui:tm-anomaly-management:update',
  TM_CUSTOMER_PROFILE_WIDGET: 'amls:ui:tm-customer-profile-widget:read',
  TM_ASSOCIATED_CUSTOMER_WIDGET: 'amls:ui:tm-associated-customer-widget:read',
  TM_ASSOCIATED_ACCOUNTS_WIDGET: 'amls:ui:tm-associated-accounts-widget:read',
  TM_ANOMALY_DISPOSITION_NOTES_WIDGET: 'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
  TM_EXPLAINABILITY_WIDGET: 'amls:ui:tm-explainability-widget:read',
  TM_TRANSACTION_DETAILS_WIDGET: 'amls:ui:tm-transaction-details-widget:read',
  TM_ALERT_DETAILS_WIDGET: 'amls:ui:tm-alert-details-widget:read',
  TM_CUSTOMER_ACTIVITY_WIDGET: 'amls:ui:tm-customer-activity-widget:read',
  TM_ADDITIONAL_INFO_WIDGET: 'amls:ui:tm-additional-info-widget:read',
  TM_RISK_INDICATOR_WIDGET: 'amls:ui:tm-risk-indicator-widget:read',
  TM_CLUSTER_INFORMATION_WIDGET: 'amls:ui:tm-cluster-information-widget:read'
};

export const crsResources = {
  APP_3_RESOURCE_UI_CRS_DASHBOARD: 'amls:ui:crs-dashboard:read',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST: 'amls:ui:crs-customer-list:read',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL: 'amls:ui:crs-customer-detail:read',
  APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION:
    'amls:ui:crs-risk-indicator-configuration:read',
  APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS: 'amls:ui:crs-global-settings:read',
  APP_3_RESOURCE_UI_CRS_CONFIGURE_RULES: 'amls:ui:crs-configure-rules:read',
  APP_3_RESOURCE_UI_CRS_TRIGGER_RE_SCORING:
    'amls:ui:crs-trigger-re-scoring:write',
  APP_3_RESOURCE_UI_CRS_CHANGE_OR_ACCEPT_RISK_SCORE:
    'amls:ui:crs-change-or-accept-risk-score:read'
};

export const trmResources = {
  APP_3_RESOURCE_UI_TYPOLOGY: 'amls:ui:typology:read',
  APP_3_RESOURCE_UI_TYPOLOGY_WRITE: 'amls:ui:typology:write',
  APP_3_RESOURCE_UI_RUN_INSTANCE: 'amls:ui:run-instance:read',
  APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS: 'amls:ui:tm-alert-details:read',
  APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS: 'amls:ui:common-alerts:read',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'amls:ui:tm-global-settings:read',
  APP_3_RESOURCE_UI_AMLS_CHAMPION: 'amls:ui:champion:read',
  APP_3_RESOURCE_UI_AMLS_CHAMPION_UPDATE: 'amls:ui:champion:update',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'amls:ui:common-ticket:read',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE: 'amls:ui:common-ticket:write',
  APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS: 'amls:ui:tm-ticket-details:read',
  APP_3_RESOURCE_UI_SEGMENT_DETAILS: 'amls:ui:segment-details:read'
};

export const cmResources = {
  APP_7_RESOURCE_UI_CM_GENERIC: 'cm:ui:generic:full',
  APP_7_RESOURCE_UI_CM_DASHBOARD: 'cm:ui:dashboard:full',
  APP_7_RESOURCE_UI_CM_ALERT_LIST: 'cm:ui:alert-list:full',
  APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS: 'cm:ui:own-alerts-actions:full',
  APP_7_RESOURCE_UI_CM_ALERT_HISTORY: 'cm:ui:alert-history:full',
  APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS:
    'cm:ui:others-alerts-actions:full',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS:
    'cm:ui:unassigned-alerts-actions:full',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS: 'cm:ui:unassigned-alerts:full',
  APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT: 'cm:ui:cases-by-department:full',
  APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR:
    'cm:ui:cases-by-investigator:full',
  APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS: 'cm:ui:own-cases-actions:full',
  APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS: 'cm:ui:others-cases-actions:full',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS:
    'cm:ui:unassigned-cases-actions:full',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES: 'cm:ui:unassigned-cases:full',
  APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION: 'cm:ui:manual-case-creation:full',
  APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW:
    'cm:ui:case-resolution-review:full',
  APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY: 'cm:ui:dashboard-summary:full',
  APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR:
    'cm:ui:dashboard-cases-by-investigator:full',
  APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS: 'cm:ui:others-departments:full',
  APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES: 'cm:ui:email-preferences:full',
  APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS: 'cm:ui:general-settings:full',
  APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS: 'cm:ui:automation-settings:full',
  APP_7_RESOURCE_UI_CM_REGULATORY_REPORT: 'cm:ui:regulatory-report:full',
  APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES: 'cm:ui:workflow-statuses:full',
  APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT: 'cm:ui:operational-report:full',
  APP_7_RESOURCE_UI_CM_WHITELISTS: 'cm:ui:whitelists:full'
};

export const sandboxResources = {
  APP_3_RESOURCE_UI_SCREENING_SANDBOX: 'amls:ui:screening-sandbox:read'
};

export const CRS_UI_DYNPROPS = 'amls:ui:crs-dyn-props-list-page:read';
export const CRS_UI_PIPELINES = 'amls:ui:crs-pipeline-list-page:read';

export const NS_UI_DYNPROPS = 'amls:ui:ns-iad-dyn-props-list-page:read';
export const NS_UI_PIPELINES = 'amls:ui:ns-iad-pipeline-list-page:read';

export const TS_UI_DYNPROPS = 'amls:ui:ts-iad-dyn-props-list-page:read';
export const TS_UI_PIPELINES = 'amls:ui:ts-iad-pipeline-list-page:read';

export const TM_UI_DYNPROPS = 'amls:ui:tm-iad-dyn-props-list-page:read';
export const TM_UI_PIPELINES = 'amls:ui:tm-iad-pipeline-list-page:read';
export const TM_UI_RI_DYNPROPS = 'amls:ui:tm-iad-ri-dyn-props-list-page:read';
export const TM_UI_TYPOLOGY_DYNPROPS =
  'amls:ui:tm-iad-typology-dyn-props-list-page:read';
